import { Box, Center } from '@chakra-ui/react';
import { t } from 'i18next';
import { LoadingIcon } from '~components/ui/icons';
import { ConfigurationSyncStatus } from '~graphql/__generated__/types';

export const ColorMap = {
  [ConfigurationSyncStatus.Synced]: '#3EBD93',
  [ConfigurationSyncStatus.OutOfSync]: '#829AB1',
  [ConfigurationSyncStatus.Syncing]: '#EF8E58',
  [ConfigurationSyncStatus.Failed]: '#CF1124',
};

export const LableMap = {
  [ConfigurationSyncStatus.Synced]: t('SYNCED'),
  [ConfigurationSyncStatus.OutOfSync]: t('OUT_OF_SYNC'),
  [ConfigurationSyncStatus.Syncing]: t('SYNCING'),
  [ConfigurationSyncStatus.Failed]: t('FAILED'),
};

export const DisplaySyncStatus = ({ syncStatus }: { syncStatus: ConfigurationSyncStatus }) => {
  return (
    <Box
      whiteSpace="nowrap"
      bg={ColorMap[syncStatus]}
      px={2}
      py={1}
      borderRadius={8}
      color={'white'}
      width={'100%'}
    >
      <Center>
        {LableMap[syncStatus]}
        {syncStatus === ConfigurationSyncStatus.Syncing && (
          <Box mx={2}>
            <LoadingIcon color="white" />
          </Box>
        )}
      </Center>
    </Box>
  );
};
